import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  //constructor(private authService: AuthService, private spinner: NgxSpinnerService) { }
  constructor(private authService: AuthService) 
  {
    this.login();
  }

  title = "Iniciar Sesión";

  login() {
   //this.spinner.show();
    this.authService.login();
  }

  ngOnInit() {
  }
}
